import merge from 'lodash/merge'
import debounce from 'lodash/debounce'
import React, {useEffect, useRef, useState} from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import Legend from "./Legend";
import PropTypes from "prop-types";
import isEqual from "lodash/isEqual";


const commonOptions = {
  chart: {
    backgroundColor: "transparent"
  },
  credits: {
    enabled: false
  },
  legend: false,
  title: {
    text: ''
  },
  colors: ['#FF513C', '#222222', '#FED3CF', '#888888', '#B2382B','#DDDDDD', '#FEA89E', '#77a1e5', '#c42525', '#FED3CF'],
  exporting: false
};

function autoResizeChart (chartComponent) {
  const chart = chartComponent.current.chart;
  const resizeChart = debounce(() => {
    if (chart.container) { chart.reflow() }
  }, 300);
  const resizeObserver = new ResizeObserver( resizeChart );
  resizeObserver.observe(chart.container.parentNode);
}

function Chart(props) {

  const getLegendOptions = () => (merge({
    show: true,
    clickable: false
  }, props.legendOptions));

  const mergedOptions = () => {
    return merge({}, commonOptions, props.options)
  }

  const [seriesOptions, setSeriesOptions] = useState([]);
  const [legendOptions, setLegendOptions] = useState(getLegendOptions())
  const [options, setOptions] = useState(mergedOptions());

  const chartComponent = useRef(null);

  // Causes charts to always redraw once after initial rendering, this solves the issue but consequences need to be investigated
  // useEffect(() => {
  //   autoResizeChart(chartComponent);
  // }, []);

  useEffect(() => {
    const chart = chartComponent.current.chart;
    if (chart.series.length > 1) {
      setSeriesOptions(chart.series);
    } else if (chart.series.length === 1) {
      setSeriesOptions(chart.series[0].data);
    }
  }, [props.options])

  useEffect(() => {
    setLegendOptions(getLegendOptions())
  }, [props.legendOptions]);

  useEffect(() => {
    setOptions(mergedOptions())
  }, [props.options]);

  return (
    <>
      <HighchartsReact
        highcharts={Highcharts}
        containerProps={{style: { height: "100%" } }}
        options={options}
        ref={chartComponent}
      />
      <Legend seriesOptions={seriesOptions} show={legendOptions.show} clickable={legendOptions.clickable} />
    </>
  )
}

Chart.propTypes = {
  options: PropTypes.shape({
    series: PropTypes.array.isRequired
  }).isRequired,
  legendOptions: PropTypes.shape({
    show: PropTypes.bool,
    clickable: PropTypes.bool
  })
}

Chart.defaultProps = {
  legendOptions: {}
};


export default React.memo(Chart, isEqual);
